














































import { defineComponent, computed, ref, onUnmounted } from '@vue/composition-api';
import { DropdownOption } from 'tdesign-vue';

import Login from '@/renderer/components/login/components/index.vue';
import LoginAnimation from '@/renderer/components/login/components/loginAnimation.vue';
import switchOrg from '@/renderer/components/user/components/switchOrg.vue';
import SettingDialog from '@/renderer/components/dialog/setting/index.vue';
import { i18n_t, LanguageOptions } from '@/locales/i18n';
import tips from '@/renderer/scripts/utils/tips';
import { getDeviceName } from '@/renderer/scripts/utils/tools/index';
import { dispatchRouter } from '@/renderer/scripts/utils/tools/dispatchRouter';
import ipc, { IpcEvents } from '@/renderer/scripts/utils/ipc';
import { setLanguage } from '@/locales/languageSettingMethod';
import { CONSTANT_URL } from '@/renderer/scripts/http';
import { decodeText } from '@/renderer/scripts/utils/tools/packages/encrypt';

export default defineComponent({
  components: {
    Login,
    LoginAnimation,
    switchOrg,
    SettingDialog,
  },
  setup(props, context) {
    const vm = context.root;
    const store = context.root.$store;
    const thisYear = new Date().getFullYear();
    const customDomainInfo = computed(() => store.getters.customDomainInfo);
    const showInPc = computed(() => !store.getters.isMobile && !store.getters.isMobileStyle);
    const hiddenEntranceBtn = computed(() => store.getters.customDomainInfo.isCustomDomain);
    const showRegisterBtn = computed(() => showInPc.value && !store.getters.isInWeMeetApp && !store.getters.isPrivate);
    const showSetting = ref(false);
    const languageOptions = ref(LanguageOptions);
    const languageOptionsMobile = ref(LanguageOptions);
    const loginLoading = () => {
      let timer: any = setTimeout(() => {
        store.commit('setLoginingMask', false);
        clearTimeout(timer);
        timer = null;
      }, 500);
    };

    const methods = {
      // 登录成功后执行
      logined({ loginPath }: { loginPath: string }) {
        tips.success(i18n_t('登录成功'));
        // 三方登录重定向后会携带path path进行了先加密再2次encodeURI 这里需要反解一下
        let routePath = decodeText(decodeURIComponent(decodeURIComponent(loginPath)));
        if (!routePath) {
          // 解密失败 兜底使用原loginPath
          routePath = loginPath;
        }
        if (routePath && routePath !== '/login') {
          dispatchRouter({ path: routePath }, 'replace');
        } else {
          let routerName = store.getters.isMobileStyle ? 'recentUse' : 'workbench';
          // 若登录时企业已过期自动跳转至过期页面
          if (store.getters.orgExpired) {
            routerName = 'teamExpired';
          }
          dispatchRouter(
            {
              name: routerName,
            },
            'replace',
          );
        }
        loginLoading();
      },
      // 免费注册
      freeRegister() {
        dispatchRouter({
          name: 'register',
          query: {
            from: 'login',
          },
        });
      },
      // 前往cofile官网
      goCoFileIndex(target = '_self') {
        dispatchRouter(CONSTANT_URL.officialWebsiteUrl, target);
      },
      // 统计来源
      reportSource() {
        reporter.report('browser_type', {
          browser_type: getDeviceName(),
        });
        const { source, type, uid } = vm.$route.query;
        // uid非必须
        if (source && type) {
          reporter.report('enter_login', {
            source: source || '',
            uid: uid || '',
            type: type || '',
          });
        }
      },
      // 响应托盘菜单消息
      onTrayMenuEvent(e: Event, params: any) {
        const { event } = params;
        switch (event) {
          case 'update':
            ipc.emit(ipc.RENDERER_EVENTS_MAP.CHECK_UPDATE);
            break;
          case 'setting':
            showSetting.value = true;
            break;
          default:
            break;
        }
      },
      onLanguageChange(dropdownItem: DropdownOption) {
        setLanguage(dropdownItem.value as string);
      },
      jumpFillingNumber(type: 'icp' | 'psb') {
        if (type === 'icp') {
          // icp备案号跳转链接
          dispatchRouter(CONSTANT_URL.govICPUrl);
        } else {
          // 公安备案号跳转链接
          dispatchRouter(`${CONSTANT_URL.govPsbUrl}?recordcode=${customDomainInfo.value.psbNumber}`);
        }
      },
    };
    methods.reportSource();
    ipc.on(IpcEvents.MENU_CLICK, methods.onTrayMenuEvent);
    onUnmounted(() => {
      ipc.off(IpcEvents.MENU_CLICK, methods.onTrayMenuEvent);
    });
    return {
      thisYear,
      customDomainInfo,
      showInPc,
      showRegisterBtn,
      hiddenEntranceBtn,
      showSetting,
      languageOptions,
      languageOptionsMobile,
      ...methods,
    };
  },
});
